"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var jwt_decode_1 = __importDefault(require("jwt-decode"));
var lodash_1 = require("lodash");
var objectIndexer_1 = require("./objectIndexer");
var storage = __importStar(require("./storage"));
var v4_1 = __importDefault(require("uuid/v4"));
var lodash_2 = require("lodash");
var query_string_1 = __importDefault(require("query-string"));
var recompose_1 = require("recompose");
var react_redux_1 = require("react-redux");
var actions_1 = require("./actions");
var hashArray = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return args
        .map(function (arg) {
        switch (typeof arg) {
            case 'function':
            case 'object':
                return arg ? objectIndexer_1.objectIndex(arg) : 'null';
            default:
                return arg;
        }
    })
        .join();
};
exports.mpartial = lodash_1.memoize(function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return lodash_1.partial.apply(void 0, __spread(args));
}, function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return hashArray.apply(void 0, __spread(args));
} // maybe refactor using pretty-format
);
exports.replace = function (array, oldValue, newValue) { return array.map(function (value) { return (value === oldValue ? newValue : value); }); };
exports.noop = function () { };
exports.identity = function (o) { return o; };
exports.contains = function (items, id) { return items.indexOf(id) !== -1; };
exports.removePrefix = function (string, prefix) {
    if (string === void 0) { string = null; }
    return string !== null && string.startsWith(prefix) ? string.substring(prefix.length) : string;
};
exports.join = function () {
    var fns = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        fns[_i] = arguments[_i];
    }
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return fns.filter(function (fn) { return fn instanceof Function; }).forEach(function (fn) { return fn.apply(void 0, __spread(args)); });
    };
};
exports.getDecodedToken = function () {
    var token = storage.get('token');
    if (!token) {
        return null;
    }
    return jwt_decode_1.default(token);
};
exports.createAction = function (type, value) { return ({
    type: type,
    payload: value,
}); };
exports.errorRoute = function (err) {
    console.error('Dynamic page loading failed', err); // eslint-disable-line no-console
};
exports.loadRoute = function (cb) { return function (module) { return cb(null, module.default); }; };
exports.idObj = function (obj) {
    if (obj === void 0) { obj = {}; }
    return (lodash_2.isUndefined(obj.id) ? __assign({ id: v4_1.default() }, obj) : obj);
};
exports.idImmutable = function (obj) { return (lodash_2.isEmpty(obj.get('id')) ? obj.set('id', v4_1.default()) : obj); };
exports.getUser = function () {
    var token = storage.get('token');
    if (token) {
        try {
            return jwt_decode_1.default(token);
        }
        catch (e) {
            console.warn('Unable to parse user', e);
            return null;
        }
    }
    return null;
};
exports.findItem = function (array, field, value) {
    if (value == null) {
        return null;
    }
    return lodash_1.find(array, function (item) { return item[field] === value; });
};
exports.getProperty = function (object, pathFunction) {
    if (object != null) {
        return pathFunction(object);
    }
    else {
        return null;
    }
};
exports.safe = function (mapper, def) { return function (value) {
    if (value == null) {
        return def;
    }
    else {
        return mapper(value);
    }
}; };
exports.formatDateWithoutZone = function (date) {
    var pattern = /(\d{4})-(\d{2})-(\d{2})T(\d{1,2}):(\d{1,2}).*/;
    return date.replace(pattern, '$3. $2. $1 $4:$5');
};
exports.isoStringToDateWithoutZone = function (isoString) {
    var match = isoString.match(/(\d{4})-(\d{2})-(\d{2})T(\d{1,2}):(\d{1,2}).*/);
    var date = new Date();
    date.setFullYear(Number(match[1]));
    date.setMonth(Number(match[2]) - 1);
    date.setDate(Number(match[3]));
    date.setHours(Number(match[4]));
    date.setMinutes(Number(match[5]));
    return date;
};
exports.existUrlParam = function (location, name) { return query_string_1.default.parse(location.search)[name] !== undefined; };
exports.getUrlParam = function (location, name) { return query_string_1.default.parse(location.search)[name]; };
exports.setUrlParam = function (location, name, value) {
    if (value === void 0) { value = null; }
    var parsed = query_string_1.default.parse(location.search);
    parsed[name] = value;
    return location.pathname + '?' + query_string_1.default.stringify(parsed);
};
exports.delUrlParams = function (location) {
    var names = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        names[_i - 1] = arguments[_i];
    }
    var parsed = query_string_1.default.parse(location.search);
    names.forEach(function (name) { return delete parsed[name]; });
    return location.pathname + '?' + query_string_1.default.stringify(parsed);
};
exports.setAndDeleteUrlParams = function (location, nameToSet, valueToSet) {
    var names = [];
    for (var _i = 3; _i < arguments.length; _i++) {
        names[_i - 3] = arguments[_i];
    }
    var parsed = query_string_1.default.parse(location.search);
    parsed[nameToSet] = valueToSet;
    names.forEach(function (name) { return delete parsed[name]; });
    return location.pathname + '?' + query_string_1.default.stringify(parsed);
};
exports.breadcrumbs = function (value) {
    return recompose_1.compose(react_redux_1.connect(null, { setBreadcrumbs: actions_1.setBreadcrumbs }), recompose_1.lifecycle({
        componentDidMount: function () {
            if (value instanceof Function) {
                this.props.setBreadcrumbs(value(this.props));
            }
            else {
                this.props.setBreadcrumbs(value);
            }
        },
        componentWillUpdate: function (nextProps) {
            if (value instanceof Function) {
                this.props.setBreadcrumbs(value(nextProps));
            }
            else {
                this.props.setBreadcrumbs(value);
            }
        },
    }));
};
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// .-core/es/utils/index.js
// module id = 20
// module chunks = 0